<template>
  <!-- پیشخوان -->
  <li v-if="!childrenLinks && isHeader" :class="{ headerLink: true, className }">
    <router-link :to="link" class="sidebar-link">
      <span class="icon">
        <i :class="fullIconName"></i>
      </span>
      {{ header }} <sup v-if="label" :class="'text-' + labelColor" class="headerLabel">{{ label }}</sup>
      <b-badge v-if="badge" variant="primary" pill>{{ badge }}</b-badge>
    </router-link>
  </li>

  <!-- لایه ی یک -->
  <li v-else-if="childrenLinks && isParent == 0" :class="{ headerLink: true, className }">
    <div @click="() => togglePanelCollapse(link)">
      <router-link :to="link" event="" class="d-flex sidebar-link">
        <span class="icon">
          <i style="font-size: 18px; color: var(--logo-color)" :class="fullIconName"></i>
        </span>
        <div :class="{ caretWrapper: true, carretActive: isActive }">
          <i class="fa fa-angle-left" />
        </div>
        {{ header }} <sup v-if="label" :class="'text-' + labelColor" class="ml-1 headerLabel">{{ label }}</sup>
      </router-link>
    </div>
    <b-collapse :id="'collapse' + index" :visible="isActive">
      <ul class="sub-menu">
        <NavLink v-for="link in childrenLinks" :activeItem="activeItem" :header="link.header" :index="link.index" :link="link.link" :childrenLinks="Getchild(link.children)" :key="link.id" :isParent="1" :menuId="link.id" />
      </ul>
    </b-collapse>
  </li>

  <!-- لایه ی دو -->
  <li v-else-if="isParent == 1">
    <template v-if="childrenLinks.length > 0">
      <div @click="toggele(menuId)">
        <router-link :to="link" event="" class="d-flex sidebar-link">
          <span class="icon">
            <i style="font-size: 18px; color: var(--logo-color)" :class="fullIconName"></i>
          </span>
          <div :class="{ caretWrapper: true, carretActive: isActive }">
            <i class="fa fa-angle-left subangle" :id="'angle' + menuId" />
          </div>
          {{ header }} <sup v-if="label" :class="'text-' + labelColor" class="ml-1 headerLabel">{{ label }}</sup>
        </router-link>
      </div>
      <b-collapse :visible="true">
        <ul class="sub-menu d-none level2" :id="'s' + menuId">
          <NavLink v-for="link in childrenLinks" :activeItem="activeItem" :header="link.header" :index="link.index" :link="link.link" :childrenLinks="link.children" :key="link.id" :isParent="2" :menuId="link.id" />
        </ul>
      </b-collapse>
    </template>
    <!-- -------------------------- -->
    <template v-else>
      <router-link :to="index !== 'menu' && link" replace>
        {{ header }} <sup v-if="label" :class="'text-' + labelColor" class="headerLabel">{{ label }}</sup>
      </router-link>
    </template>
  </li>

  <!-- لایه ی سه -->
  <li v-else-if="isParent == 2">
    <router-link :to="index !== 'menu' && link" replace>
      {{ header }} <sup v-if="label" :class="'text-' + labelColor" class="headerLabel">{{ label }}</sup>
    </router-link>
  </li>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'NavLink',
  props: {
    badge: { type: String, default: '' },
    header: { type: String, default: '' },
    iconName: { type: String, default: '' },
    c: { type: String, default: '' },
    headerLink: { type: String, default: '' },
    link: { type: String, default: '' },
    childrenLinks: { type: Array, default: null },
    className: { type: String, default: '' },
    isHeader: { type: Boolean, default: false },
    deep: { type: Number, default: 0 },
    activeItem: { type: String, default: '' },
    label: { type: String },
    labelColor: { type: String, default: 'warning' },
    index: { type: String },
    isParent: { type: Number },
    menuId: { type: Number },
  },
  data() {
    return {
      headerLinkWasClicked: true,
      AllMenu: {},
      lableMenu: null,
    }
  },
  methods: {
    ...mapActions('layout', ['changeSidebarActive']),
    togglePanelCollapse(link) {
      this.changeSidebarActive(link)
      this.headerLinkWasClicked = !this.headerLinkWasClicked || !this.activeItem.includes(this.index)
    },
    toggele(menuId) {
      let collapse = document.getElementById('s' + menuId)
      var disapearList = document.querySelectorAll('.level2:not(#s' + menuId + ')')
      var rotateList = document.getElementsByClassName('subangle')
      var arr = Array.prototype.slice.call(rotateList)
      arr.forEach((el) => {
        el.style.transform = 'rotate(0)'
      })
      if (!document.getElementById('s' + menuId).classList.contains('d-none')) {
        document.getElementById('angle' + menuId).style.transform = 'rotate(0)'
      } else {
        document.getElementById('angle' + menuId).style.transform = 'rotate(-90deg)'
      }
      collapse.classList.toggle('d-none')
      disapearList.forEach((Element) => {
        Element.classList.add('d-none')
      })
    },
    Getchild(arr) {
      var a = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].IsMenu && arr[i].RouteName != '-' && arr[i].isMojaz) {
          a.push({ header: arr[i].label, link: arr[i].RouteName, children: arr[i].Children, menuId: arr[i].id })
        }
      }
      return a
    },
  },
  created() {},

  computed: {
    fullIconName() {
      return `${this.iconName}`
    },
    isActive() {
      return this.activeItem && this.activeItem.includes(this.index) && this.headerLinkWasClicked
    },
  },
}
</script>

<style src="./NavLink.scss" lang="scss" scoped />
<style>
.sub-menu > li > a:after {
  content: '' !important;
  color: var(--logo-color) !important;
  font-size: large;
  margin-left: 2px !important;
}
.sub-menu > li > a {
  padding: 10px 20px 10px 15px !important;
}
.sub-menu > li > div > a {
  padding: 10px 20px 10px 15px !important;
}

.sub-menu.d-none {
  border: none;
}

.sub-menu > li > .collapse.show > .sub-menu > li {
  border-right: 2px solid var(--logo-color) !important;
}
/*.headerLink > div > .sub-menu > li {
  border-right: 0.5px solid var(--logo-color) !important;
}*/
</style>
